commonModule.factory('commonRESTCallService', ['$http','$window','AppSettings', function ($http, $window, AppSettings) {
    var commonRESTCaller = {};
    var timeOut = 120000;

    var sessionTokenKey = AppSettings.SESSION_IM_TOKEN;
    var locateUserToken = function(){
        userToken = $window.sessionStorage.getItem(sessionTokenKey);
        return userToken;
    }

    commonRESTCaller.postToServer = function(url, postData) {
        if (locateUserToken() != null){
            return commonRESTCaller.postToServerWithToken(url, postData, locateUserToken());
        }
        else
            return $http(
                {
                    method: 'POST',
                    url: url,
                    headers: {'Content-type': 'application/json'},
                    data: postData,
                    timeout: timeOut
                });
    };

    commonRESTCaller.postToServerWithToken = function(url, postData, token) {
        return $http(
            {
                method: 'POST',
                url: url,
                headers: {'Content-type': 'application/json', 'authorization' : token},
                data: postData
            });
    };

    commonRESTCaller.getFromServer = function(url) {
        if (locateUserToken() != null){
            return commonRESTCaller.getFromServerWithToken(url, locateUserToken());
        }
        else {
            return $http(
                {
                    method: 'GET',
                    url: url,
                    headers: {'Content-type': 'application/json'},
                    timeout: timeOut
                });
        }
    };

    commonRESTCaller.getFromServerWithToken = function(url, token) {
        return $http(
            {
                method: 'GET',
                url: url,
                headers: {'Content-type': 'application/json', 'authorization' : token},
                timeout: timeOut
            });
    };

    commonRESTCaller.putToServer = function(url, putData) {
        if (locateUserToken() != null){
            return commonRESTCaller.putToServerWithToken(url, putData, locateUserToken());
        }
        else {
            return $http(
                {
                    method: 'PUT',
                    url: url,
                    headers: {'Content-type': 'application/json'},
                    data: putData,
                    timeout: timeOut
                });
        }
    };

    commonRESTCaller.putToServerWithToken = function(url, putData, token) {
        return $http(
            {
                method: 'PUT',
                url: url,
                headers: {'Content-type': 'application/json', 'authorization' : token},
                data: putData,
                timeout: timeOut
            });
    };

    commonRESTCaller.deleteToServer = function(url) {
        if (locateUserToken() != null){
            return commonRESTCaller.deleteToServerWithToken(url, locateUserToken());
        }else {
            return $http(
                {
                    method: 'DELETE',
                    url: url,
                    headers: {'Content-type': 'application/json'},
                    timeout: timeOut
                });
        }
    };

    commonRESTCaller.deleteToServerWithToken = function(url, token) {
        return $http(
            {
                method: 'DELETE',
                url: url,
                headers: {'Content-type': 'application/json', 'authorization' : token},
                timeout: timeOut
            });
    };

    return commonRESTCaller;
}]);
